import { createRoutine } from 'redux-saga-routines'

export const SET = 'PROTAGONISTA_DETAILS_LAYOUT/SET'
export const CONTENT = createRoutine('PROTAGONISTA_DETAILS_LAYOUT/CONTENT')
